import { render, staticRenderFns } from "./FieldFileList.vue?vue&type=template&id=96082ee6&scoped=true"
import script from "./FieldFileList.vue?vue&type=script&lang=js"
export * from "./FieldFileList.vue?vue&type=script&lang=js"
import style0 from "./FieldFileList.vue?vue&type=style&index=0&id=96082ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96082ee6",
  null
  
)

export default component.exports